import React from 'react'

export type SvgIconProps = {
  fill?: string
  className?: string
  width?: string
  height?: string
}

const SvgInboxIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="15"
    fill="none"
    viewBox="0 0 20 15"
  >
    <path
      fill={fill ?? "#353535"}
      d="M19.91 8.086L16.454.469c0-.235-.358-.469-.715-.469H4.292c-.358 0-.715.234-.834.469L.119 8.086C0 8.203 0 8.32 0 8.437v5.626c0 .468.358.937.835.937h18.241c.477 0 .835-.352.835-.938V8.439c.119-.118.119-.235 0-.352zM2.266 7.617L3.1 5.86v1.758h-.835zM3.577 4.57l.715-1.758v1.641h-.358c-.119.117-.238.117-.357.117zm13.591 3.047V6.328l.597 1.29h-.597zm-1.55-4.687l.716 1.64h-.715V3.047 2.93zM13.83 4.57H6.2v-.703h7.75l-.12.703zm.954-2.46H5.246c-.239 0-.477.117-.715.35l.357-.702h10.254l.357.703c-.238-.234-.477-.352-.715-.352zM4.888 6.327H15.5v1.29h-2.146c-.477 0-.834.35-.834.702 0 .117-.477 2.11-2.385 2.11-1.907 0-2.265-1.992-2.384-2.11-.12-.351-.477-.703-.954-.703H4.888V6.328zm5.127 5.86c2.146 0 3.338-1.407 3.934-2.813h4.292v3.867H1.788V9.375H6.08c.597 1.406 1.789 2.813 3.935 2.813z"
    ></path>
  </svg>
)


export default SvgInboxIcon